import { render, staticRenderFns } from "./stepCompensation.vue?vue&type=template&id=08c32e49&scoped=true&"
import script from "./stepCompensation.vue?vue&type=script&lang=js&"
export * from "./stepCompensation.vue?vue&type=script&lang=js&"
import style0 from "./stepCompensation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./stepCompensation.vue?vue&type=style&index=1&id=08c32e49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c32e49",
  null
  
)

export default component.exports